import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import * as api from './api'

export const partyKeys = {
  list: (contractId: number) => ['contract', contractId, 'parties'] as const,
  roles: ['contract-party-roles'] as const,
}

export function useParties(contractId: number) {
  return useQuery({
    queryKey: partyKeys.list(contractId),
    queryFn: () => api.listParties(contractId),
    enabled: !!contractId,
  })
}

export function usePartyRoles() {
  return useQuery({ queryKey: partyKeys.roles, queryFn: api.listPartyRoles })
}

export function useAddParty(contractId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ customerId, roleCode }: { customerId: number; roleCode: string }) =>
      api.addParty(contractId, customerId, roleCode),
    onSuccess: () => qc.invalidateQueries({ queryKey: partyKeys.list(contractId) }),
  })
}

export function useDeleteParty(contractId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (partyId: number) => api.deleteParty(partyId),
    onSuccess: () => qc.invalidateQueries({ queryKey: partyKeys.list(contractId) }),
  })
}
